import { keysToSnakeCase } from "neetocist";
import { stringify, parse } from "qs";
import {
  mergeRight,
  isEmpty,
  pipe,
  tail,
  toPairs,
  fromPairs,
  filter,
} from "ramda";
import { useHistory } from "react-router-dom";

const useQueryUpdater = () => {
  const history = useHistory();

  const updateQuery = newParams => {
    const currentSearch = history.location.search;

    if (isEmpty(newParams)) {
      history.replace("/");

      return;
    }

    const newQueryString = pipe(
      tail,
      parse,
      existingParams => mergeRight(existingParams, newParams),
      paramsAfterMerge => {
        if (paramsAfterMerge.page === 1) {
          return { ...paramsAfterMerge, page: null };
        }

        return paramsAfterMerge;
      },
      toPairs,
      filter(([, value]) => value !== null && value !== ""),
      fromPairs,

      keysToSnakeCase,
      stringify
    )(currentSearch);

    const finalQuery = isEmpty(newQueryString) ? "/" : `?${newQueryString}`;
    history.replace(finalQuery);
  };

  return updateQuery;
};

export default useQueryUpdater;
